import InlineAdvertisementEditing from "./inlineadvertisementediting"
import InlineAdvertisementUI from "./inlineadvertisementui"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class InlineAdvertisement extends Plugin {
  static get requires() {
    return [InlineAdvertisementEditing, InlineAdvertisementUI]
  }

  static get pluginName() {
    return "InlineAdvertisement"
  }
}
